import React from 'react';

export const artifacts = (
  <svg width="100%" height="100%">
    <g
      id="Home-page"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      transform="translate(-141.000000, -3986.000000)"
      fillOpacity="0.49999997"
    >
      <g id="Footer" transform="translate(0.000000, 3864.000000)">
        <g id="Group-2" transform="translate(140.000000, 0.000000)">
          <g
            id="Artifacts-Copy"
            transform="translate(892.500000, 281.500000) rotate(-280.000000) translate(-892.500000, -281.500000) translate(745.000000, 71.000000)"
          >
            <path
              className="animate-artifact"
              d="M8.10237873,413.352379 L3.19848481,413.352379 C1.81777294,413.352379 0.69848481,412.233091 0.69848481,410.852379 C0.69848481,409.471667 1.81777294,408.352379 3.19848481,408.352379 L8.10237873,408.352379 L8.10237873,403.138225 C8.10237873,401.757513 9.22166686,400.638225 10.6023787,400.638225 C11.9830906,400.638225 13.1023787,401.757513 13.1023787,403.138225 L13.1023787,408.352379 L17.8046323,408.352379 C19.1853441,408.352379 20.3046323,409.471667 20.3046323,410.852379 C20.3046323,412.233091 19.1853441,413.352379 17.8046323,413.352379 L13.1023787,413.352379 L13.1023787,418.066532 C13.1023787,419.447244 11.9830906,420.566532 10.6023787,420.566532 C9.22166686,420.566532 8.10237873,419.447244 8.10237873,418.066532 L8.10237873,413.352379 Z"
              id="Combined-Shape"
              fill="#8DF5FF"
              fillRule="nonzero"
            />
            <path
              className="animate-artifact"
              d="M158.146896,80.0782769 L154.821687,80.0782769 C153.440975,80.0782769 152.321687,78.9589887 152.321687,77.5782769 C152.321687,76.197565 153.440975,75.0782769 154.821687,75.0782769 L158.146896,75.0782769 L158.146896,71.5089622 C158.146896,70.1282503 159.266184,69.0089622 160.646896,69.0089622 C162.027608,69.0089622 163.146896,70.1282503 163.146896,71.5089622 L163.146896,75.0782769 L166.31346,75.0782769 C167.694172,75.0782769 168.81346,76.197565 168.81346,77.5782769 C168.81346,78.9589887 167.694172,80.0782769 166.31346,80.0782769 L163.146896,80.0782769 L163.146896,83.2542033 C163.146896,84.6349151 162.027608,85.7542033 160.646896,85.7542033 C159.266184,85.7542033 158.146896,84.6349151 158.146896,83.2542033 L158.146896,80.0782769 Z"
              id="Combined-Shape"
              fill="#97DDFF"
              fillRule="nonzero"
            />
            <circle
              className="animate-artifact"
              id="Oval-5"
              fill="#97DDFF"
              cx="290.120887"
              cy="4.67096013"
              r="4.5"
            />
            <circle
              className="animate-artifact"
              id="Oval-5-Copy"
              fill="#20D9FF"
              cx="115.137085"
              cy="208.696393"
              r="7"
            />
            <rect
              className="animate-artifact"
              id="Rectangle-4"
              fill="#AAF8FF"
              transform="translate(18.511972, 296.781180) rotate(-19.000000) translate(-18.511972, -296.781180) "
              x="9.69421292"
              y="287.96342"
              width="17.6355191"
              height="17.6355191"
            />
            <rect
              className="animate-artifact"
              id="Rectangle-4-Copy"
              fill="#97DEFF"
              transform="translate(250.222106, 119.700928) rotate(51.000000) translate(-250.222106, -119.700928) "
              x="246.657651"
              y="116.136472"
              width="7.12891094"
              height="7.12891094"
            />
          </g>
          <g
            id="Artifacts-Copy-2"
            transform="translate(244.500000, 203.500000) rotate(-107.000000) translate(-244.500000, -203.500000) translate(97.000000, -7.000000)"
          >
            <path
              className="animate-artifact"
              d="M8.10237873,413.352379 L3.19848481,413.352379 C1.81777294,413.352379 0.69848481,412.233091 0.69848481,410.852379 C0.69848481,409.471667 1.81777294,408.352379 3.19848481,408.352379 L8.10237873,408.352379 L8.10237873,403.138225 C8.10237873,401.757513 9.22166686,400.638225 10.6023787,400.638225 C11.9830906,400.638225 13.1023787,401.757513 13.1023787,403.138225 L13.1023787,408.352379 L17.8046323,408.352379 C19.1853441,408.352379 20.3046323,409.471667 20.3046323,410.852379 C20.3046323,412.233091 19.1853441,413.352379 17.8046323,413.352379 L13.1023787,413.352379 L13.1023787,418.066532 C13.1023787,419.447244 11.9830906,420.566532 10.6023787,420.566532 C9.22166686,420.566532 8.10237873,419.447244 8.10237873,418.066532 L8.10237873,413.352379 Z"
              id="Combined-Shape"
              fill="#8DF5FF"
              fillRule="nonzero"
            />
            <path
              className="animate-artifact"
              d="M158.146896,80.0782769 L154.821687,80.0782769 C153.440975,80.0782769 152.321687,78.9589887 152.321687,77.5782769 C152.321687,76.197565 153.440975,75.0782769 154.821687,75.0782769 L158.146896,75.0782769 L158.146896,71.5089622 C158.146896,70.1282503 159.266184,69.0089622 160.646896,69.0089622 C162.027608,69.0089622 163.146896,70.1282503 163.146896,71.5089622 L163.146896,75.0782769 L166.31346,75.0782769 C167.694172,75.0782769 168.81346,76.197565 168.81346,77.5782769 C168.81346,78.9589887 167.694172,80.0782769 166.31346,80.0782769 L163.146896,80.0782769 L163.146896,83.2542033 C163.146896,84.6349151 162.027608,85.7542033 160.646896,85.7542033 C159.266184,85.7542033 158.146896,84.6349151 158.146896,83.2542033 L158.146896,80.0782769 Z"
              id="Combined-Shape"
              fill="#97DDFF"
              fillRule="nonzero"
            />
            <circle
              className="animate-artifact"
              id="Oval-5"
              fill="#97DDFF"
              cx="290.120887"
              cy="4.67096013"
              r="4.5"
            />
            <circle
              className="animate-artifact"
              id="Oval-5-Copy"
              fill="#20D9FF"
              cx="115.137085"
              cy="208.696393"
              r="7"
            />
            <rect
              className="animate-artifact"
              id="Rectangle-4"
              fill="#AAF8FF"
              transform="translate(18.511972, 296.781180) rotate(-19.000000) translate(-18.511972, -296.781180) "
              x="9.69421292"
              y="287.96342"
              width="17.6355191"
              height="17.6355191"
            />
            <rect
              className="animate-artifact"
              id="Rectangle-4-Copy"
              fill="#97DEFF"
              transform="translate(250.222106, 119.700928) rotate(51.000000) translate(-250.222106, -119.700928) "
              x="246.657651"
              y="116.136472"
              width="7.12891094"
              height="7.12891094"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const logo = (
  <svg width="205px" height="26px" viewBox="0 0 205 26">
    <defs>
      <linearGradient
        x1="0%"
        y1="0%"
        x2="101.999998%"
        y2="100.999999%"
        id="logo-gradient-1"
      >
        <stop stopColor="#3CBDFF" offset="0%" />
        <stop stopColor="#87FFE1" offset="100%" />
      </linearGradient>
      <path
        d="M1.49970574,8.46347163 C0.671413851,8.46331249 0,7.79120457 0,6.96214037 C0,6.13297799 0.671572875,5.46080908 1.5,5.46080908 C2.06898804,5.46080908 2.56398252,5.77789436 2.81821403,6.24514751 C4.40525943,4.36285585 6.88985896,3.15106863 9.68263473,3.15106863 C10.5202149,3.15106863 11.3300759,3.26006373 12.096319,3.46345252 L13.6275976,2.28080049 C14.0646963,1.94321617 14.692701,2.02388851 15.0302853,2.46098721 C15.1875183,2.66456999 15.2602535,2.92091299 15.2333731,3.1767364 L15.0562151,4.86276712 C16.3975464,5.83572685 17.4185428,7.1647156 17.9501186,8.69444571 L19,8.69444571 C20.1045695,8.69444571 21,9.58987621 21,10.6944457 L21,11.5449007 C21,12.6494702 20.1045695,13.5449007 19,13.5449007 L17.9501186,13.5449007 C17.6348243,14.4522316 17.1473495,15.2889407 16.5229767,16.0226248 L16.7168625,16.2165106 C17.4979111,16.9975592 17.4979111,18.2638892 16.7168625,19.0449377 L15.8107496,19.9510506 C15.029701,20.7320992 13.7633711,20.7320992 12.9823225,19.9510506 L12.38096,19.3496882 C12.2170531,19.1857812 12.0875428,19.0005029 11.9924292,18.802823 C11.2570035,18.988888 10.4824573,19.0882777 9.68263473,19.0882777 C8.76473328,19.0882777 7.88012224,18.9573757 7.04972701,18.7147895 C6.97416202,18.8317261 6.88516327,18.9425052 6.78273076,19.0449377 L5.87661788,19.9510506 C5.09556929,20.7320992 3.82923934,20.7320992 3.04819075,19.9510506 L2.44682829,19.3496882 C1.66577971,18.5686396 1.66577971,17.3023096 2.44682829,16.521261 L2.88995954,16.0781298 C1.71065339,14.7172997 1.00598802,12.9940629 1.00598802,11.1196732 C1.00598802,10.1883148 1.179967,9.2942755 1.49970574,8.46347163 Z M13.2664671,9.1563938 C13.7873344,9.1563938 14.2095808,8.76860404 14.2095808,8.29024113 C14.2095808,7.81187822 13.7873344,7.42408846 13.2664671,7.42408846 C12.7455997,7.42408846 12.3233533,7.81187822 12.3233533,8.29024113 C12.3233533,8.76860404 12.7455997,9.1563938 13.2664671,9.1563938 Z M9.68263473,4.65239992 C7.92963823,4.65239992 6.27571458,5.24333897 4.99447469,6.29387795 C4.839056,6.42131184 4.82554895,6.64032784 4.96430585,6.78306387 C5.10306276,6.9257999 5.3415392,6.93820473 5.49695789,6.81077083 C6.64123442,5.8725335 8.11679688,5.34532206 9.68263473,5.34532206 C9.89098167,5.34532206 10.0598802,5.19020615 10.0598802,4.99886099 C10.0598802,4.80751582 9.89098167,4.65239992 9.68263473,4.65239992 Z"
        id="logo-path-2"
      />
      <filter
        x="-33.3%"
        y="-27.1%"
        width="166.7%"
        height="175.8%"
        filterUnits="objectBoundingBox"
        id="logo-filter-3"
      >
        <feOffset dx="0" dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          stdDeviation="2"
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
        />
        <feColorMatrix
          values="0 0 0 0 0.11865424   0 0 0 0 0.130071879   0 0 0 0 0.538823342  0 0 0 0.5 0"
          type="matrix"
          in="shadowBlurOuter1"
        />
      </filter>
    </defs>
    <g
      id="Artboard"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      transform="translate(-20.000000, -23.000000)"
    >
      <g id="ic-logo" transform="translate(24.000000, 23.000000)">
        <g id="logo-mark">
          <g id="Combined-Shape">
            <use
              fill="black"
              fillOpacity="1"
              filter="url(#logo-filter-3)"
              xlinkHref="#logo-path-2"
            />
            <use
              fill="url(#logo-gradient-1)"
              fillRule="evenodd"
              xlinkHref="#logo-path-2"
            />
          </g>
          <g id="Group-25" transform="translate(3.000000, 0.000000)" />
          <circle id="logo-Oval-6" fill="#FEE743" cx="6" cy="3" r="3" />
          <ellipse
            id="Oval-6-Copy-2"
            fill="#DFCB40"
            cx="6"
            cy="3"
            rx="2.28571429"
            ry="2.14285714"
          />
        </g>
        <text
          id="Investment"
          fontFamily="Avenir Next"
          fontSize="16"
          fontWeight="bold"
          fill="#6EDAFA"
        >
          <tspan x="29.640625" y="18">
            Investment
          </tspan>
        </text>
        <text
          id="Calculator"
          fontFamily="Avenir Next"
          fontSize="16"
          fontWeight="normal"
          fill="currentColor"
        >
          <tspan x="120" y="18">
            Calculator
          </tspan>
        </text>
      </g>
    </g>
  </svg>
);

export const calendarIcon = (
  <svg
    style={{
      transform: 'translateY(2px)'
    }}
    width="14px"
    height="16px"
    viewBox="0 0 16 16"
  >
    <g
      id="Home-page"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      transform="translate(-1088.000000, -153.000000)"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <g
        id="Results"
        transform="translate(695.000000, 118.000000)"
        stroke="#D9D7EE"
        strokeWidth="2"
      >
        <g id="Best-case">
          <g id="retirement-year" transform="translate(394.000000, 35.000000)">
            <g id="Group-33" transform="translate(0.000000, 1.000000)">
              <path d="M5,6.99543677 L5,6.99543677" id="Stroke-86" />
              <path d="M9,6.99543677 L9,6.99543677" id="Stroke-87" />
              <path d="M5,9.9934811 L5,9.9934811" id="Stroke-88" />
              <path d="M9,9.9934811 L9,9.9934811" id="Stroke-89" />
              <path d="M3,3.99739244 L3,0" id="Stroke-90" />
              <path d="M11,3.99739244 L11,0" id="Stroke-91" />
              <path
                d="M13,13.9908735 L1,13.9908735 C0.447,13.9908735 0,13.5431656 0,12.9915254 L0,2.99804433 C0,2.44640417 0.447,1.99869622 1,1.99869622 L13,1.99869622 C13.553,1.99869622 14,2.44640417 14,2.99804433 L14,12.9915254 C14,13.5431656 13.553,13.9908735 13,13.9908735 Z"
                id="Stroke-92"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const accountIcon = (
  <svg width="14px" height="16px" viewBox="0 0 14 16">
    <g
      id="Home-page"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      transform="translate(-1198.000000, -153.000000)"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <g
        id="Results"
        transform="translate(695.000000, 118.000000)"
        stroke="#D9D7EE"
        strokeWidth="2"
      >
        <g id="Best-case">
          <path
            d="M513,39 C513,40.657 511.657,42 510,42 C508.343,42 507,40.657 507,39 C507,37.343 508.343,36 510,36 C511.657,36 513,37.343 513,39 Z M516,50 L504,50 C504,47.239 506.238,45 509,45 L511,45 C513.762,45 516,47.239 516,50 Z"
            id="account"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const bedIcon = (
  <svg width="43px" height="37px" viewBox="0 0 43 37">
    <defs />
    <g
      id="Desktop-02-Copy-19"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      transform="translate(-710.000000, -1032.000000)"
    >
      <g id="Group-13" transform="translate(682.000000, 1008.000000)">
        <g id="Group-21-Copy" transform="translate(28.000000, 24.000000)">
          <rect
            id="Rectangle-9"
            fill="#D0E0E9"
            x="1"
            y="1"
            width="31"
            height="25"
          />
          <polygon
            id="Rectangle-9-Copy-6"
            fill="#BDD1DD"
            points="1 1 0.29045463 0.370666501 0.29045463 25.3706665 1 26"
          />
          <polygon
            id="Rectangle-9-Copy-7"
            fill="#BDD1DD"
            points="1 1 0.29045463 0.370666501 31.2594041 0.370666501 31.9689494 1"
          />
          <polygon
            id="Rectangle-8-Copy-3"
            fill="#4F8BD6"
            points="8.22245644 23.5134821 42.7234667 23.3208218 32.0086849 13.0910916 1.19899949 13.0910916"
          />
          <polygon
            id="Rectangle-8-Copy-4"
            fill="#7AAEF0"
            points="8.12691777 31.5351176 8.12691777 23.4256496 1.12520229 12.9985703 1.12520229 20.9726618"
          />
          <g id="Group-22" transform="translate(10.000000, 29.000000)">
            <rect
              id="Rectangle-9-Copy"
              fill="#D0E0E9"
              x="1"
              y="2"
              width="2"
              height="6"
            />
            <polygon
              id="Rectangle-9-Copy-3"
              fill="#BDD1DD"
              points="1 1.75 0 0 0 6.25 1 8"
            />
          </g>
          <g id="Group-22-Copy" transform="translate(37.000000, 29.000000)">
            <rect
              id="Rectangle-9-Copy"
              fill="#D0E0E9"
              x="1"
              y="2"
              width="2"
              height="6"
            />
            <polygon
              id="Rectangle-9-Copy-3"
              fill="#BDD1DD"
              points="1 1.75 0 0 0 6.25 1 8"
            />
          </g>
          <path
            d="M9,23 L42,23 C42.5522847,23 43,23.4477153 43,24 L43,31 C43,31.5522847 42.5522847,32 42,32 L9,32 C8.44771525,32 8,31.5522847 8,31 L8,24 C8,23.4477153 8.44771525,23 9,23 Z"
            id="Rectangle-8"
            fill="#6AA4ED"
          />
          <path
            d="M5.5,10 L12.5,10 C13.3284271,10 14,10.6715729 14,11.5 L14,11.5 C14,12.3284271 13.3284271,13 12.5,13 L5.5,13 C4.67157288,13 4,12.3284271 4,11.5 L4,11.5 C4,10.6715729 4.67157288,10 5.5,10 Z"
            id="Rectangle-8-Copy"
            fill="#FFFFFF"
          />
          <path
            d="M6.5,12 L13.5,12 C14.3284271,12 15,12.6715729 15,13.5 L15,13.5 C15,14.3284271 14.3284271,15 13.5,15 L6.5,15 C5.67157288,15 5,14.3284271 5,13.5 L5,13.5 C5,12.6715729 5.67157288,12 6.5,12 Z"
            id="Rectangle-8-Copy-5"
            fill="#F8F0F0"
          />
          <g id="Group-24" transform="translate(19.000000, 10.000000)">
            <path
              d="M1.5,0 L8.5,0 C9.32842712,-1.52179594e-16 10,0.671572875 10,1.5 L10,1.5 C10,2.32842712 9.32842712,3 8.5,3 L1.5,3 C0.671572875,3 1.01453063e-16,2.32842712 0,1.5 L0,1.5 C-1.01453063e-16,0.671572875 0.671572875,1.52179594e-16 1.5,0 Z"
              id="Rectangle-8-Copy-6"
              fill="#FFFFFF"
            />
            <path
              d="M2.5,2 L9.5,2 C10.3284271,2 11,2.67157288 11,3.5 L11,3.5 C11,4.32842712 10.3284271,5 9.5,5 L2.5,5 C1.67157288,5 1,4.32842712 1,3.5 L1,3.5 C1,2.67157288 1.67157288,2 2.5,2 Z"
              id="Rectangle-8-Copy-7"
              fill="#F8F0F0"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const bikeIcon = (
  <svg width="38px" height="24px" viewBox="0 0 38 24">
    <defs>
      <linearGradient
        x1="0%"
        y1="0%"
        x2="101.999998%"
        y2="100.999999%"
        id="bike-gradient-1"
      >
        <stop stopColor="#FF2547" offset="0%" />
        <stop stopColor="#FF78CA" offset="52.0906409%" />
        <stop stopColor="#FF879B" offset="100%" />
      </linearGradient>
      <linearGradient
        x1="0%"
        y1="0%"
        x2="101.999998%"
        y2="100.999999%"
        id="bike-gradient-2"
      >
        <stop stopColor="#5C5047" offset="0%" />
        <stop stopColor="#473C2F" offset="100%" />
      </linearGradient>
    </defs>
    <g
      id="bike-group1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      transform="translate(-701.000000, -1323.000000)"
    >
      <g id="bike-group-2" transform="translate(682.000000, 1296.000000)">
        <g id="bike-group-3" transform="translate(21.000000, 27.000000)">
          <g id="bike-group-4">
            <ellipse
              id="bike-Oval-3"
              stroke="#000000"
              strokeWidth="3"
              cx="5.91304348"
              cy="16.1333333"
              rx="5.91304348"
              ry="5.86666667"
            />
            <polygon
              id="bike-Triangle-3"
              stroke="url(#linearGradient-1)"
              strokeWidth="2"
              strokeLinejoin="round"
              points="9.60869565 5.86666667 15.2253716 16.8846013 5.91304348 16.1333333"
            />
            <path
              d="M7.3475798,1.46666667 L10.3032966,7.30880045"
              id="bike-Line-Copy-2"
              stroke="url(#bike-gradient-1)"
              strokeWidth="2"
              strokeLinejoin="round"
            />
            <path
              d="M4.64023805,1.46666667 L10.3478261,1.46666667"
              id="bike-Line-Copy-3"
              stroke="#473C2F"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <polygon
              id="bike-Triangle-3-Copy-2"
              stroke="url(#bike-gradient-1)"
              strokeWidth="2"
              strokeLinejoin="round"
              points="15.2126404 16.8450791 9.66284231 5.86666667 23.9353855 5.86666667"
            />
            <ellipse
              id="bike-Oval-3-Copy"
              stroke="#000000"
              strokeWidth="3"
              cx="28.0869565"
              cy="16.1333333"
              rx="5.91304348"
              ry="5.86666667"
            />
            <path
              d="M29.5855671,5.37696212 L29.5976347,5.37696212 C30.677433,5.37696212 31.5527824,4.50161267 31.5527824,3.42181439 L31.5527824,3.42181439 C31.5527824,2.34201612 30.677433,1.46666667 29.5976347,1.46666667 L22.173913,1.46666667 L28.5511263,16.1967985"
              id="bike-Line-Copy"
              stroke="url(#bike-gradient-1)"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const coffeeIcon = (
  <svg width="20px" height="30px" viewBox="0 0 20 30">
    <defs>
      <linearGradient
        x1="0%"
        y1="0%"
        x2="100%"
        y2="100%"
        id="coffee-gradient-1"
      >
        <stop stopColor="#5D460D" offset="0%" />
        <stop stopColor="#A15411" offset="100%" />
      </linearGradient>
    </defs>
    <g
      id="Desktop-02-Copy-19"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      transform="translate(-123.000000, -1028.000000)"
    >
      <g id="Group-9" transform="translate(102.000000, 1008.000000)">
        <g id="1" transform="translate(21.000000, 20.000000)">
          <g>
            <path
              d="M0.993816434,8.76679028 L0.712023627,8.76679028 C0.318827171,8.76679028 0,8.44281787 0,8.04363758 L0,6.38291739 C0,5.05593218 1.06252002,3.97590361 2.36878625,3.97590361 L17.6280112,3.97590361 C18.9357008,3.97590361 20,5.0555706 20,6.38291739 L20,8.04363758 C20,8.44281787 19.6811728,8.76679028 19.2883322,8.76679028 L19.0092882,8.76679028 L17.7137672,26.5512848 C17.5931395,28.482464 16.0018503,30 14.0913781,30 L5.90897769,30 C3.99814966,30 2.40686048,28.4821025 2.28623279,26.5440532 L0.993816434,8.76679028 Z"
              id="Combined-Shape"
              fill="#F2F2F5"
            />
            <path
              d="M1.81818182,13.370567 L2.77811097,26.4635703 C2.87729185,28.0452466 4.17691549,29.2771084 5.74645279,29.2771084 L13.8916819,29.2771084 C15.4615734,29.2771084 16.7608429,28.0452466 16.8600237,26.4632126 L17.8181818,13.3644864 C17.8181818,13.3644864 14.4435526,11.7563415 9.81818182,13.3673478 C5.192811,14.9783542 1.81818182,13.370567 1.81818182,13.370567 L1.81818182,13.370567 Z"
              id="Shape"
              fill="url(#coffee-gradient-1)"
            />
            <path
              d="M4.01846865,3.97590361 L3.64996643,1.20007495 C3.64943136,1.19604441 3.64891949,1.19201082 3.64843083,1.18797439 C3.57806754,0.606757554 3.99219616,0.0785474972 4.573413,0.00818420731 C5.16332744,-0.0632320324 5.70089851,0.353264333 5.77909771,0.942317993 L6.18181818,3.97590361 L4.01846865,3.97590361 Z"
              id="Shape"
              fill="#A7ABAC"
            />
            <path
              d="M4,3.97590361 L6.04181327,3.97590361 L8.72200871,25.1821821 C8.76769565,25.5489709 8.51092792,25.8841771 8.1486198,25.9301154 L7.4509199,26.018762 C7.08861177,26.0650593 6.75817827,25.8048617 6.71249132,25.437714 L4,3.97590361 Z"
              id="Combined-Shape"
              fill="#D0D5D6"
              opacity="0.262001812"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const pigIcon = (
  <svg width="40px" height="46px" viewBox="0 0 40 46">
    <defs>
      <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="pig-gradient-1">
        <stop stopColor="#F89DDC" offset="0%" />
        <stop stopColor="#FFA9CD" offset="100%" />
      </linearGradient>
    </defs>
    <g
      id="Desktop-02-Copy-19"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      transform="translate(-123.000000, -1311.000000)"
    >
      <g id="Group-7" transform="translate(102.000000, 1296.000000)">
        <g id="piggy" transform="translate(21.000000, 15.000000)">
          <path
            d="M24.1225327,14.9811602 L27.2850939,12.2438985 C27.7026862,11.8824638 28.3342125,11.9279885 28.6956472,12.3455809 C28.8407034,12.513175 28.9259681,12.7242127 28.9380441,12.9455343 L29.1654924,17.1140697 C32.0725192,18.8803369 34.2480799,21.3486967 35.2765278,24.1939171 L38,24.1939171 C39.1045695,24.1939171 40,25.0893476 40,26.1939171 L40,32.1420456 C40,33.2466151 39.1045695,34.1420456 38,34.1420456 L34.682219,34.1420456 C34.4748546,34.1420456 34.274861,34.1104872 34.086779,34.0519113 C33.1055931,35.5816591 31.7684801,36.9474786 30.1604583,38.0828455 L31.8119476,42.3851224 C32.20779,43.4163268 31.6927272,44.5731768 30.6615227,44.9690191 L28.3231892,45.8666212 C27.2919847,46.2624636 26.1351348,45.7474008 25.7392925,44.7161963 L24.2488555,40.8334752 C22.435154,41.3320116 20.4846425,41.6031419 18.4532005,41.6031419 C16.3582938,41.6031419 14.3494534,41.3148061 12.4879612,40.786086 L10.9793332,44.7161963 C10.5834909,45.7474008 9.42664093,46.2624636 8.39543646,45.8666212 L6.05710298,44.9690191 C5.02589852,44.5731768 4.51083572,43.4163268 4.90667803,42.3851224 L6.59856853,37.9775969 C3.13869425,35.478399 0.971834777,31.8994355 0.971834777,27.9244653 C0.971834777,26.4775848 1.25893156,25.0831729 1.79098161,23.7742059 C1.73330172,23.7523913 1.67611555,23.7277291 1.61959244,23.700161 L1.12371039,23.4583031 C0.1309299,22.9740917 -0.281346807,21.7767532 0.202864591,20.7839727 L0.483800287,20.2079692 C0.968011685,19.2151887 2.16535018,18.802912 3.15813067,19.2871234 L3.65401273,19.5289813 C3.88032324,19.6393603 4.07646842,19.7867962 4.23870527,19.9604187 C7.41085572,16.5000868 12.5955818,14.2457887 18.4532005,14.2457887 C20.4375618,14.2457887 22.3447004,14.5044972 24.1225327,14.9811602 Z M27.3660418,25.7340491 C28.1899555,25.7340491 28.8578695,25.0530543 28.8578695,24.2130046 C28.8578695,23.372955 28.1899555,22.6919602 27.3660418,22.6919602 C26.5421281,22.6919602 25.8742141,23.372955 25.8742141,24.2130046 C25.8742141,25.0530543 26.5421281,25.7340491 27.3660418,25.7340491 Z"
            id="Combined-Shape"
            fill="url(#pig-gradient-1)"
          />
          <path
            d="M19,18 C16.8595352,18 14.8276912,18.3571589 13,18.9981096"
            id="Oval-7"
            stroke="#CE80B1"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <g id="Group-25" transform="translate(11.000000, 9.000000)">
            <ellipse
              id="Oval-6-Copy"
              fill="#DFCB40"
              cx="3"
              cy="3.5"
              rx="3"
              ry="3.5"
            />
            <ellipse
              id="Oval-6"
              fill="#FEE743"
              cx="4"
              cy="3.5"
              rx="3"
              ry="3.5"
            />
            <ellipse
              id="Oval-6-Copy-2"
              fill="#DFCB40"
              cx="4"
              cy="3.5"
              rx="2"
              ry="2.5"
            />
          </g>
          <g id="Group-25-Copy-3" transform="translate(11.000000, 0.000000)">
            <ellipse
              id="Oval-6-Copy"
              fill="#DFCB40"
              cx="4"
              cy="3.5"
              rx="3"
              ry="3.5"
            />
            <ellipse
              id="Oval-6"
              fill="#FEE743"
              cx="3"
              cy="3.5"
              rx="3"
              ry="3.5"
            />
            <ellipse
              id="Oval-6-Copy-2"
              fill="#DFCB40"
              cx="3"
              cy="3.5"
              rx="2"
              ry="2.5"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const moneyIcon = (
  <svg width="41px" height="36px" viewBox="0 0 41 36">
    <defs>
      <radialGradient
        cx="100%"
        cy="65.8437417%"
        fx="100%"
        fy="65.8437417%"
        r="107.489376%"
        gradientTransform="translate(1.000000,0.658437),scale(1.000000,0.886895),rotate(138.891143),translate(-1.000000,-0.658437)"
        id="money-gradient-1"
      >
        <stop stopColor="#41E6D2" offset="0%" />
        <stop stopColor="#20E5DB" offset="100%" />
      </radialGradient>
      <linearGradient
        x1="100%"
        y1="65.8437417%"
        x2="14.9947322%"
        y2="131.631814%"
        id="money-gradient-2"
      >
        <stop stopColor="#CFF7EA" offset="0%" />
        <stop stopColor="#E7FEFB" offset="100%" />
      </linearGradient>
    </defs>
    <g
      id="Desktop-02-Copy-19"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      transform="translate(-418.000000, -1319.000000)"
    >
      <g id="Group-4" transform="translate(394.000000, 1296.000000)">
        <g id="Group-19" transform="translate(24.000000, 23.000000)">
          <g id="Group-21">
            <path
              d="M22.6754071,1.16427441 L35.9751007,3.43027249 C36.5195396,3.52303385 36.8856967,4.03958676 36.7929353,4.58402572 C36.7522184,4.82300326 36.6260768,5.03905347 36.4379783,5.19198184 L31.9762697,8.81945284 C28.6654954,11.5111879 27.4374588,16.0130136 28.9228051,20.0130649 L28.9939313,20.2046085 C30.4455338,24.1137873 29.3189802,28.5133716 26.16724,31.2438226 L21.2902472,35.4689139 C21.0606968,35.6677806 20.7532092,35.7515486 20.4545102,35.6965914 L7.23530363,33.2644088 C6.69213597,33.1644722 6.33282622,32.6431331 6.43276285,32.0999654 C6.47276694,31.8825384 6.58369378,31.6844967 6.74819937,31.5368053 L10.3802672,28.2759723 C13.3196373,25.6370362 14.3373882,21.4642364 12.9430975,17.7683152 L12.9430975,17.7683152 C11.5466559,14.0666926 12.5476192,9.88775404 15.4695712,7.2204978 L21.8332629,1.4115057 C22.0608823,1.20372706 22.3715929,1.11251064 22.6754071,1.16427441 Z"
              id="Rectangle-6-Copy-2"
              fill="#23AFA7"
            />
            <path
              d="M21.813901,0.298578231 L35.5512871,2.93234579 C36.093693,3.03633728 36.4490982,3.56034594 36.3451067,4.10275189 C36.3044938,4.31458354 36.1964791,4.50760654 36.0371787,4.65302129 L30.7889869,9.44374749 C27.8652642,12.1126201 26.8632755,16.2938687 28.2597724,19.9980329 L28.2597724,19.9980329 C29.6540043,23.6961892 28.6343292,27.8709662 25.6922611,30.509996 L20.9197997,34.7908851 C20.6872519,34.99948 20.3705838,35.0874155 20.0637772,35.0285938 L6.34144107,32.3977116 C5.79903512,32.2937201 5.44362997,31.7697115 5.54762146,31.2273055 C5.58876707,31.0126954 5.69907648,30.81747 5.86167877,30.6714873 L9.50792679,27.3979235 C12.4472968,24.7589875 13.4650478,20.5861876 12.0707571,16.8902664 L12.0707571,16.8902664 C10.6743154,13.1886438 11.6752788,9.00970526 14.5972308,6.34244902 L20.9514229,0.542128439 C21.184408,0.329451822 21.5040862,0.23917973 21.813901,0.298578231 Z"
              id="Rectangle-6"
              fill="url(#money-gradient-1)"
            />
            <path
              d="M22.271988,2.76051491 L30.4302035,4.65382579 C30.9681907,4.7786787 31.3031021,5.31601675 31.1782492,5.85400392 C31.1325786,6.05079718 31.0283737,6.22914289 30.8793583,6.36555322 L28.1369862,8.87594945 C25.5764455,11.2198954 24.474506,14.7598878 25.2523097,18.1430037 L26.1270937,21.9479431 C26.7827882,24.7999357 25.7359732,27.7744128 23.4386157,29.5871307 L20.0357934,32.2721097 C19.8075495,32.4522044 19.5122269,32.5240484 19.226761,32.4689255 L10.97438,30.8754074 C10.4321124,30.7706967 10.0774026,30.2462171 10.1821133,29.7039496 C10.2166289,29.5252031 10.2992841,29.3592698 10.421166,29.2240425 L12.6529852,26.7478513 C14.7743682,24.3941884 15.5108394,21.102722 14.5947968,18.0694299 L14.1630619,16.6398263 C13.0745299,13.0353701 14.2168759,9.12816405 17.0756559,6.67777956 L21.3951302,2.97537047 C21.6366164,2.76838222 21.9621658,2.68861318 22.271988,2.76051491 Z"
              id="Rectangle-6-Copy"
              fill="url(#money-gradient-2)"
            />
            <g id="Group-25" transform="translate(33.148936, 18.439024)">
              <ellipse
                id="Oval-6-Copy"
                fill="#DFCB40"
                cx="3.4893617"
                cy="3.95121951"
                rx="3.4893617"
                ry="3.95121951"
              />
              <ellipse
                id="Oval-6"
                fill="#FEE743"
                cx="4.36170213"
                cy="3.95121951"
                rx="3.4893617"
                ry="3.95121951"
              />
              <ellipse
                id="Oval-6-Copy-2"
                fill="#DFCB40"
                cx="4.36170213"
                cy="3.95121951"
                rx="2.61702128"
                ry="3.07317073"
              />
            </g>
            <ellipse
              id="Oval-6-Copy"
              fill="#DFCB40"
              cx="1.74468085"
              cy="25.902439"
              rx="1.74468085"
              ry="2.19512195"
            />
            <ellipse
              id="Oval-6"
              fill="#FEE743"
              cx="2.61702128"
              cy="25.902439"
              rx="1.74468085"
              ry="2.19512195"
            />
            <ellipse
              id="Oval-6-Copy-2"
              fill="#DFCB40"
              cx="2.61702128"
              cy="25.902439"
              rx="1"
              ry="1.31707317"
            />
            <ellipse
              id="Oval-6-Copy"
              fill="#DFCB40"
              cx="4.79787234"
              cy="10.5365854"
              rx="3.05319149"
              ry="3.51219512"
            />
            <ellipse
              id="Oval-6"
              fill="#FEE743"
              cx="3.92553191"
              cy="10.5365854"
              rx="3.05319149"
              ry="3.51219512"
            />
            <ellipse
              id="Oval-6-Copy-2"
              fill="#DFCB40"
              cx="3.92553191"
              cy="10.5365854"
              rx="2.18085106"
              ry="2.63414634"
            />
            <ellipse
              id="Oval-2"
              fill="#23AFA7"
              cx="20.0638298"
              cy="18"
              rx="4.36170213"
              ry="3.95121951"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const carIcon = (
  <svg width="35px" height="26px" viewBox="0 0 35 26">
    <defs>
      <linearGradient
        x1="0%"
        y1="0%"
        x2="101.999998%"
        y2="100.999999%"
        id="car-gradient-1"
      >
        <stop stopColor="#3023AE" offset="0%" />
        <stop stopColor="#9B57CB" offset="70.2693133%" />
        <stop stopColor="#C86DD7" offset="100%" />
      </linearGradient>
    </defs>
    <g
      id="Desktop-02-Copy-19"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      transform="translate(-416.000000, -1036.000000)"
    >
      <g id="Group-9-Copy" transform="translate(392.000000, 1008.000000)">
        <g id="Group-10" transform="translate(24.000000, 28.000000)">
          <path
            d="M5.2530767,9 L8.01803182,4.32213894 C9.95204805,1.05009334 13.8002353,-0.56993481 17.4921421,0.333682966 L21.9788707,1.43183844 C23.0803667,1.70143662 24.0156633,2.4259032 24.5520893,3.4250147 L27.2623868,8.47303501 C27.4366132,8.79753761 27.7751142,9 28.1434304,9 L31.2726579,9 C33.3312121,9 35,10.6687879 35,12.7273421 L35,17.5608834 C35,19.2177377 33.6568542,20.5608834 32,20.5608834 L3,20.5608834 C1.34314575,20.5608834 6.46995335e-16,19.2177377 4.4408921e-16,17.5608834 L2.66453526e-15,14.2530767 C1.02085243e-15,11.3518825 2.35188255,9 5.2530767,9 Z"
            id="Rectangle-5"
            fill="url(#car-gradient-1)"
          />
          <circle
            id="Oval-3"
            stroke="#FFFFFF"
            fill="#383838"
            cx="10.5"
            cy="20.5"
            r="4.5"
          />
          <circle
            id="Oval-3-Copy"
            stroke="#FFFFFF"
            fill="#383838"
            cx="25.5"
            cy="20.5"
            r="4.5"
          />
          <path
            d="M23.5149105,9.73971663 L20,9.73971663 C19.4477153,9.73971663 19,9.29200138 19,8.73971663 L19,4 C19,3.44771525 19.4477153,3 20,3 L20.7370074,3 C21.780415,3 22.7129425,3.65114832 23.0723702,4.63069476 L24.4537061,8.39524174 C24.6439543,8.91372419 24.3778679,9.48826393 23.8593854,9.67851216 C23.7490493,9.71899811 23.63244,9.73971663 23.5149105,9.73971663 Z"
            id="Path-7"
            fill="#FFFFFF"
            opacity="0.3"
          />
        </g>
      </g>
    </g>
  </svg>
);
